<template>
  <div>
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{$params['column'][pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <router-link to="/">学校首页 > </router-link>
        <span>{{$params['column'][pid]['name']}} > </span>
        <router-link :to="{path:'/evn/list',query:{pid:pid,id:id}}">{{$params['column'][pid]['children'][id]['name']}}</router-link>
      </div>
    </div>
    <div class="cont tleft pt40 pb20">
      <div class="star tleft cpointer dinline-block trans3" @click="goContent(item.id,index)" v-for="(item,index) in list" :key="item.id">
        <div class="igs ofhidden">
          <img class="trans3" :src="item['picture'][0]" alt="" width="305" height="205">
        </div>
        <div class="txt">
          <div class="nm fs18 lh17 ofhidden">{{item.title}}</div>
          <div class="zbtn mt20 border-80 tc6 br5">详细内容</div>
        </div>
      </div>
    </div>
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="id+pid"/>
  </div>
</template>

<script>
import Pagec from "./Page";
export default {
  name: "ListStar",
  components:{
    Pagec
  },
  props:[
    'id',
    'pid',
    'list',
    'total',
    'page',
    'perPage',
    'getData',
  ],
  methods:{
    goContent(id,index){
      var routeQuery = this.$route.query;
      var query = {
        article_id:id,
        num:(this.page - 1) * this.perPage + index + 1,
        pid:routeQuery.pid,
        id:routeQuery.id,
      }
      this.$router.push({path:'/evn/detail',query:query})
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/un_index/ListStar.vue